import styled from '@emotion/styled';
import { colors, text } from '../../core/styles/theme/default';

const T1 = styled.p`
  ${text.t1};
  color: ${colors.white};
`;

const T2 = styled.p`
  ${text.t2};
  color: ${colors.white};
`;

const H1 = styled.h1`
  ${text.h1};
  ${({ theme }) => theme?.stylesExtension?.typography?.h1}
`;

const H2 = styled.h2`
  ${text.h2};
  ${({ theme }) => theme?.stylesExtension?.typography?.h2}
`;

const H3 = styled.h3`
  ${text.h3};
  ${({ theme }) => theme?.stylesExtension?.typography?.h3}
`;

const H4 = styled.h4`
  ${text.h4};
`;

const H5 = styled.h5`
  ${text.h5};
`;

const H6 = styled.h6`
  ${text.h6};
`;

const P1 = styled.p`
  ${text.p1};
`;

const P2 = styled.p`
  ${text.p2};
`;

const P3 = styled.p`
  ${text.p3};
`;

const P4 = styled.p`
  ${text.p4};
`;

const L1 = styled.label`
  ${text.l1};
`;

const LEAD1 = styled.p`
  ${text.lead1};
`;

export { T1, T2, H1, H2, H3, H4, H5, H6, P1, P2, P3, P4, L1, LEAD1 };
